var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-promotion-review',{ref:"romotionReview",staticClass:"pt-promotion-review__withData",on:{"reviewPass":_vm.reviewPass}})}
var staticRenderFns = []

export { render, staticRenderFns }